<template>
  <!--基本信息的缺考标记区 -->
  <div class="basics-card-tips">
    <div class="c-name">
      <div class="n-p">
        缺考
        <br />标记
      </div>
    </div>
    <div class="c-cont">
      <span class="c-t">缺考</span>
      <span class="c-t c-b c-b0"></span>
      <!-- <span class="c-t">违纪</span>
      <span class="c-t c-b c-b1"></span> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
//基础信息区
export default {
  name: "basicsDesc",
  props: {
    sty: String,
  },
  computed: {
    ...mapGetters({
      // 答卷设置参数
      answerSheet: "answerPanel/answerSheet",
    }),
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
.basics-card-tips {
  height: 70px;
  border: 1px solid #000;
  border-top: 0;
  display: flex;
  .c-name {
    line-height: 25px;
    background: #f2f2f2;
    width: 40px;
    text-align: center;
    border-right: 1px solid #000;
    display: flex;
    align-items: center;
  }
  .n-p {
    text-align: center;
    width: 100%;
  }
  .c-cont {
    padding-top: 20px;
    padding-left: 10px;
  }
  .c-t {
    margin-right: 10px;
    display: inline-block;
    &:nth-child(3) {
      margin-left: 20px;
    }
  }
  .c-b {
    width: 18px;
    height: 8px;
    border: 1px solid #000;
  }
}
</style>
